export const formatExpirationYear = (year: number) => {
  const str = year.toString();
  return str.substr(str.length - 2);
};
